// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__whS3l","warning":"Badge_warning__8UGmC","info":"Badge_info__3g4M5","icon":"Badge_icon__QX286"};